import t, { useState as w, useEffect as N, useRef as G, useLayoutEffect as X } from "react";
import { useTheme as L, useMediaQuery as P, InputAdornment as oe, Stack as y, Typography as A, Button as V, Menu as Z, MenuItem as B, Divider as R, ListItemText as S, Paper as ae, Toolbar as z, Tabs as le, Tab as ie, styled as I, ListItemButton as T, List as O, Collapse as ce, Drawer as se, Box as ue, Badge as me, AppBar as de } from "@mui/material";
import { c as he } from "./chunk.BDpTQ-W3.js";
import { T as fe } from "./chunk.BXm3DgU4.js";
import { I as pe } from "./chunk.BcArC2HC.js";
import { jsx as M } from "react/jsx-runtime";
import { createSvgIcon as H } from "@mui/material/utils";
import { u as j } from "./chunk.BRWEp5al.js";
import { A as ge } from "./chunk.B0yLDQ2l.js";
import { M as ve, C as Ce } from "./chunk.DVkl1685.js";
import { E as _ } from "./chunk.B1uNhpja.js";
import { D } from "./chunk.BPE7K-tO.js";
import { C as Le } from "./chunk.C6aG2Vyu.js";
import { u as Ee } from "./chunk.TLGGOfPB.js";
const W = H([/* @__PURE__ */ M("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M7.35 18.5C8.66 17.56 10.26 17 12 17s3.34.56 4.65 1.5c-1.31.94-2.91 1.5-4.65 1.5s-3.34-.56-4.65-1.5m10.79-1.38C16.45 15.8 14.32 15 12 15s-4.45.8-6.14 2.12C4.7 15.73 4 13.95 4 12c0-4.42 3.58-8 8-8s8 3.58 8 8c0 1.95-.7 3.73-1.86 5.12"
}, "0"), /* @__PURE__ */ M("path", {
  d: "M12 6c-1.93 0-3.5 1.57-3.5 3.5S10.07 13 12 13s3.5-1.57 3.5-3.5S13.93 6 12 6m0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11"
}, "1")], "AccountCircleOutlined"), we = H(/* @__PURE__ */ M("path", {
  d: "M4 8h4V4H4zm6 12h4v-4h-4zm-6 0h4v-4H4zm0-6h4v-4H4zm6 0h4v-4h-4zm6-10v4h4V4zm-6 4h4V4h-4zm6 6h4v-4h-4zm0 6h4v-4h-4z"
}), "Apps"), K = H(/* @__PURE__ */ M("path", {
  d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), "ExpandLess"), $ = H(/* @__PURE__ */ M("path", {
  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2M9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9zm9 14H6V10h12zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2"
}), "LockOutlined"), Pe = H(/* @__PURE__ */ M("path", {
  d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), "Menu"), F = H(/* @__PURE__ */ M("path", {
  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2m6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5z"
}), "NotificationsOutlined"), ye = "data:image/svg+xml,%3csvg%20width='174'%20height='40'%20viewBox='0%200%20174%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M52.5946%2024.3013C52.0205%2025.0778%2051.0267%2026.1426%2049.79%2026.1426H47.0297C46.5437%2026.1426%2046.0139%2025.9653%2045.6605%2025.7433C45.1966%2025.4771%2044.3134%2024.5676%2044.0484%2024.1683C43.7834%2023.7686%2043.6951%2023.325%2043.6951%2022.9034V15.9145C43.6951%2015.4931%2043.7834%2015.0715%2044.0484%2014.6722C44.3134%2014.295%2045.1966%2013.3408%2045.6605%2013.0746C46.0139%2012.8749%2046.5437%2012.6753%2047.0297%2012.6753H49.79C51.0267%2012.6753%2052.0205%2013.7625%2052.5946%2014.5168C52.7713%2014.7609%2052.8596%2014.9382%2053.0583%2015.2935L50.8058%2015.9367C50.8058%2015.9367%2050.1433%2015.1157%2049.812%2014.9161C49.79%2014.8939%2049.7457%2014.8939%2049.7237%2014.8939H47.118C47.0737%2014.8939%2047.0297%2014.9161%2047.0297%2014.9161C46.7426%2015.0715%2046.2567%2015.5374%2046.0359%2015.8924C46.0139%2015.9367%2046.0139%2016.092%2046.0139%2016.1363V22.8815C46.0139%2023.1475%2046.6984%2023.7243%2047.0297%2023.902C47.0517%2023.924%2047.1621%2023.924%2047.1841%2023.924H49.7017C49.7237%2023.924%2049.768%2023.924%2049.812%2023.902C50.276%2023.68%2050.8058%2022.8591%2050.8058%2022.8591L53.0583%2023.458C52.8816%2023.8576%2052.7713%2024.0572%2052.5946%2024.3013Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M54.6188%2025.9344H57.7399V22.7656H54.6188V25.9344Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M67.1468%2026.1426V20.58H62.3776V26.1426H60.0807V12.6753H62.3776V18.328H67.1468V12.6753H69.4439V26.1426H67.1468Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M71.7848%2025.9344H74.9059V22.7656H71.7848V25.9344Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M89.1995%2015.8057C89.1995%2015.8057%2089.1995%2015.6929%2089.1766%2015.648C89.0399%2015.4004%2088.6752%2014.9498%2088.4473%2014.9273H84.3215V18.5756H88.3332C88.5383%2018.5756%2088.9944%2018.1476%2089.1766%2017.8324C89.1766%2017.8324%2089.1995%2017.7875%2089.1995%2017.7423V15.8057ZM91.1826%2019.1386C90.9773%2019.4315%2090.2708%2020.1071%2089.9517%2020.3324C89.7694%2020.4674%2089.5643%2020.58%2089.3592%2020.6476L92.0717%2026.1426H89.4731L86.9429%2020.8276H84.3215V26.1426H81.9282V12.6753H88.3332C88.8803%2012.6753%2089.4958%2012.8555%2089.9517%2013.1707C90.2708%2013.396%2090.9773%2014.1165%2091.1826%2014.4095C91.4559%2014.815%2091.5928%2015.3101%2091.5928%2015.783V17.765C91.5928%2018.2604%2091.4559%2018.7333%2091.1826%2019.1386Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M96.7586%2022.8591C96.7586%2022.8591%2096.7586%2022.9257%2096.7809%2022.9479C97.049%2023.3474%2097.5182%2023.7686%2097.7641%2023.902C97.8086%2023.924%2097.8534%2023.924%2097.8757%2023.924H101.093C101.093%2023.924%20101.16%2023.924%20101.205%2023.902C101.451%2023.7686%20101.92%2023.3474%20102.188%2022.9479C102.21%2022.9034%20102.21%2022.8591%20102.21%2022.8591V16.0033C102.21%2016.0033%20102.21%2015.9147%20102.188%2015.8924C101.92%2015.4931%20101.451%2015.0491%20101.205%2014.9161C101.16%2014.8939%20101.115%2014.8939%20101.093%2014.8939H97.8757C97.8757%2014.8939%2097.7863%2014.8939%2097.7641%2014.9161C97.5182%2015.0491%2097.049%2015.4931%2096.7809%2015.8924C96.7586%2015.9367%2096.7586%2016.0033%2096.7586%2016.0033V22.8591ZM104.199%2024.146C103.908%2024.5231%20103.037%2025.4771%20102.567%2025.7433C102.21%2025.9653%20101.652%2026.1426%20101.182%2026.1426H97.7863C97.2949%2026.1426%2096.7586%2025.9653%2096.4011%2025.7433C95.9319%2025.4771%2095.0382%2024.5231%2094.77%2024.146C94.5019%2023.7467%2094.4125%2023.3027%2094.4125%2022.8815V15.9367C94.4125%2015.5152%2094.5019%2015.0715%2094.77%2014.6722C95.0382%2014.295%2095.9319%2013.3408%2096.4011%2013.0748C96.7586%2012.8528%2097.2949%2012.6753%2097.7863%2012.6753H101.182C101.652%2012.6753%20102.21%2012.8528%20102.567%2013.0748C103.037%2013.3408%20103.908%2014.295%20104.199%2014.6722C104.467%2015.0715%20104.556%2015.5152%20104.556%2015.9367V22.8815C104.556%2023.3027%20104.467%2023.7467%20104.199%2024.146Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M114.716%2022.9897V21.391C114.716%2021.3232%20114.694%2021.2782%20114.694%2021.2782C114.495%2020.9179%20114.074%2020.5124%20113.875%2020.5124H110.001V23.8906H113.897C114.096%2023.8906%20114.539%2023.4853%20114.694%2023.1474C114.694%2023.1474%20114.716%2023.0798%20114.716%2022.9897ZM114.716%2017.4271V15.8282C114.716%2015.7833%20114.694%2015.7156%20114.694%2015.7156C114.495%2015.3553%20114.074%2014.9273%20113.875%2014.9273H110.001V18.328H113.897C114.096%2018.328%20114.539%2017.9227%20114.694%2017.5848C114.694%2017.5848%20114.716%2017.5399%20114.716%2017.4271ZM116.664%2024.4309C116.465%2024.7239%20115.801%2025.4219%20115.491%2025.647C115.048%2025.9624%20114.428%2026.1426%20113.897%2026.1426H107.677V12.6753H113.897C114.473%2012.6753%20115.048%2012.8779%20115.491%2013.1934C115.801%2013.4185%20116.465%2014.1165%20116.664%2014.4095C116.952%2014.8374%20117.04%2015.3553%20117.04%2015.8057V17.472C117.04%2018.4181%20116.686%2018.9135%20116.177%2019.4315C116.686%2019.9494%20117.04%2020.4223%20117.04%2021.3683V23.0798C117.04%2023.5527%20116.93%2024.0258%20116.664%2024.4309Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M120.161%2026.1426H122.502V12.6753H120.161V26.1426Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M133.31%2026.1426L128.728%2017.202V26.1426H126.404V12.6753H128.905L133.442%2021.7285V12.6753H135.767V26.1426H133.31Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M148.66%2024.146C148.381%2024.5455%20147.451%2025.4771%20146.963%2025.7433C146.591%2025.943%20146.01%2026.1426%20145.522%2026.1426H141.478C140.107%2026.1426%20139.13%2025.0778%20138.526%2024.3013C138.34%2024.0572%20138.294%2023.9465%20138.108%2023.6134L140.409%2022.8812C140.409%2022.8812%20140.874%2023.5023%20141.431%2023.902C141.431%2023.902%20141.478%2023.924%20141.594%2023.924H145.406C145.498%2023.924%20145.545%2023.902%20145.545%2023.902C145.894%2023.7243%20146.591%2023.0588%20146.591%2022.8812V21.5723C146.591%2021.3726%20146.428%2021.2173%20146.312%2021.1951L140.269%2019.5533C139.084%2019.2425%20138.456%2018.1553%20138.456%2017.135V15.9367C138.456%2015.5595%20138.526%2015.0715%20138.805%2014.6722C139.084%2014.2729%20140.037%2013.3408%20140.525%2013.0746C140.897%2012.8749%20141.455%2012.6753%20141.966%2012.6753H145.406C146.8%2012.6753%20147.753%2013.7625%20148.357%2014.5168C148.543%2014.7609%20148.66%2014.9606%20148.822%2015.2932L146.475%2015.9367C146.475%2015.9367%20145.94%2015.2045%20145.452%2014.9161C145.452%2014.9161%20145.429%2014.8939%20145.313%2014.8939H142.036C141.943%2014.8939%20141.896%2014.9161%20141.896%2014.9161C141.524%2015.0936%20140.897%2015.7149%20140.897%2015.8924V17.0017C140.897%2017.2016%20141.036%2017.3567%20141.152%2017.3789L147.219%2019.065C148.404%2019.3755%20149.031%2020.4851%20149.031%2021.4835V22.8812C149.031%2023.2584%20148.962%2023.7467%20148.66%2024.146Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M153.718%2022.8591C153.718%2022.8591%20153.718%2022.9257%20153.741%2022.9479C154.009%2023.3474%20154.478%2023.7686%20154.724%2023.902C154.768%2023.924%20154.813%2023.924%20154.835%2023.924H158.053C158.053%2023.924%20158.12%2023.924%20158.164%2023.902C158.41%2023.7686%20158.879%2023.3474%20159.148%2022.9479C159.17%2022.9034%20159.17%2022.8591%20159.17%2022.8591V16.0033C159.17%2016.0033%20159.17%2015.9147%20159.148%2015.8924C158.879%2015.4931%20158.41%2015.0491%20158.164%2014.9161C158.12%2014.8939%20158.075%2014.8939%20158.053%2014.8939H154.835C154.835%2014.8939%20154.746%2014.8939%20154.724%2014.9161C154.478%2015.0491%20154.009%2015.4931%20153.741%2015.8924C153.718%2015.9367%20153.718%2016.0033%20153.718%2016.0033V22.8591ZM161.158%2024.146C160.868%2024.5231%20159.997%2025.4771%20159.527%2025.7433C159.17%2025.9653%20158.611%2026.1426%20158.142%2026.1426H154.746C154.255%2026.1426%20153.718%2025.9653%20153.361%2025.7433C152.892%2025.4771%20151.998%2024.5231%20151.73%2024.146C151.462%2023.7467%20151.372%2023.3027%20151.372%2022.8815V15.9367C151.372%2015.5152%20151.462%2015.0715%20151.73%2014.6722C151.998%2014.295%20152.892%2013.3408%20153.361%2013.0748C153.718%2012.8528%20154.255%2012.6753%20154.746%2012.6753H158.142C158.611%2012.6753%20159.17%2012.8528%20159.527%2013.0748C159.997%2013.3408%20160.868%2014.295%20161.158%2014.6722C161.427%2015.0715%20161.516%2015.5152%20161.516%2015.9367V22.8815C161.516%2023.3027%20161.427%2023.7467%20161.158%2024.146Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M171.543%2026.1426L166.961%2017.202V26.1426H164.637V12.6753H167.138L171.676%2021.7285V12.6753H174V26.1426H171.543Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M12.5603%209.35053L16.3097%207.20382V16.146L17.1655%2016.6359L18.0224%2016.1454V7.20405L21.7713%209.35053L22.6278%207.87973L17.1657%204.75293L11.704%207.87973L12.5603%209.35053Z'%20fill='%2300A3E0'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M10.0765%2028.6407L6.41218%2026.506L14.0449%2022.0597V21.0848L13.2073%2020.5972L5.57509%2025.0434V20.7739H3.90137V26.9938L9.23962%2030.1035L10.0765%2028.6407Z'%20fill='%2300A3E0'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M31.9034%2028.7341L16.7758%2037.6639L1.64841%2028.7341V10.8754L16.7758%201.94584L31.9034%2010.8754V28.7341ZM16.7758%200L0%209.90238V29.7074L16.7758%2039.6098L33.5516%2029.7074V9.90238L16.7758%200Z'%20fill='%2300A3E0'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M23.4639%2010.9566L27.1349%2013.073L16.7755%2019.0456L6.41697%2013.073L10.0879%2010.9566L9.24933%209.50635L3.90137%2012.5896V18.756H5.57836V14.5231L15.938%2020.4956L15.9375%2032.44L12.2663%2030.3233L11.4277%2031.7735L16.7757%2034.8566L22.1239%2031.7733L21.2853%2030.3231L17.6143%2032.4395V20.4947L27.9733%2014.5231V18.756H29.6502V12.5896L24.3023%209.50657L23.4639%2010.9566Z'%20fill='%2300A3E0'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M27.9764%2020.7741V25.0434L20.3432%2020.5972L19.5067%2021.0843V22.0602L27.1395%2026.5062L23.4749%2028.641L24.3118%2030.1035L29.6502%2026.9938V20.7741H27.9764Z'%20fill='%2300A3E0'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M34.3318%2033.2724H34.0861V31.9496H34.0786L33.5903%2033.2724H33.4352L32.9468%2031.9496H32.9396V33.2724H32.6936V31.688H33.0733L33.5181%2032.8918L33.9558%2031.688H34.3318V33.2724ZM32.3898%2031.8993H31.9234V33.2724H31.6774V31.8993H31.2108V31.688H32.3898V31.8993Z'%20fill='%2300A3E0'/%3e%3c/svg%3e", Me = "data:image/svg+xml,%3csvg%20width='35'%20height='40'%20viewBox='0%200%2035%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M12.5603%209.5456L16.3097%207.39889V16.3411L17.1655%2016.8309L18.0224%2016.3404V7.39911L21.7713%209.5456L22.6278%208.0748L17.1657%204.948L11.704%208.0748L12.5603%209.5456Z'%20fill='%2300A3E0'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M10.0765%2028.8358L6.41218%2026.701L14.0449%2022.2548V21.2798L13.2073%2020.7922L5.57509%2025.2385V20.9689H3.90137V27.1889L9.23962%2030.2986L10.0765%2028.8358Z'%20fill='%2300A3E0'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M31.9034%2028.9292L16.7758%2037.859L1.64841%2028.9292V11.0705L16.7758%202.14091L31.9034%2011.0705V28.9292ZM16.7758%200.195068L0%2010.0975V29.9024L16.7758%2039.8048L33.5516%2029.9024V10.0975L16.7758%200.195068Z'%20fill='%2300A3E0'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M23.4639%2011.1516L27.1349%2013.2681L16.7755%2019.2406L6.41697%2013.2681L10.0879%2011.1516L9.24933%209.70142L3.90137%2012.7847V18.9511H5.57836V14.7181L15.938%2020.6907L15.9375%2032.6351L12.2663%2030.5184L11.4277%2031.9686L16.7757%2035.0517L22.1239%2031.9684L21.2853%2030.5181L17.6143%2032.6346V20.6898L27.9733%2014.7181V18.9511H29.6502V12.7847L24.3023%209.70164L23.4639%2011.1516Z'%20fill='%2300A3E0'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M27.9764%2020.9692V25.2385L20.3432%2020.7922L19.5067%2021.2794V22.2552L27.1395%2026.7013L23.4749%2028.836L24.3118%2030.2986L29.6502%2027.1889V20.9692H27.9764Z'%20fill='%2300A3E0'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M34.3318%2033.4674H34.0861V32.1447H34.0786L33.5903%2033.4674H33.4352L32.9468%2032.1447H32.9396V33.4674H32.6936V31.8831H33.0733L33.5181%2033.0869L33.9558%2031.8831H34.3318V33.4674ZM32.3898%2032.0944H31.9234V33.4674H31.6774V32.0944H31.2108V31.8831H32.3898V32.0944Z'%20fill='%2300A3E0'/%3e%3c/svg%3e", Q = (e) => {
  const n = L(), r = P(n.breakpoints.down("md"));
  return /* @__PURE__ */ t.createElement(
    fe,
    {
      "data-testid": e["data-testid"],
      placeholder: e.placeholder || "Search",
      inputValue: e.inputValue,
      onInputChange: e.onInputChange,
      endAdornment: "search",
      InputProps: {
        size: r ? "medium" : "small",
        onKeyUp: (a) => {
          a.key === "Enter" && e.onSearch(a);
        },
        endAdornment: /* @__PURE__ */ t.createElement(oe, { position: "end" }, /* @__PURE__ */ t.createElement(
          pe,
          {
            ariaLabel: "search",
            onClick: (a) => e.onSearch(a),
            icon: "search"
          }
        ))
      }
    }
  );
}, J = () => {
  var c, l;
  const e = j(), n = L();
  if (e.name === "" || e.email === "")
    throw new Error(
      "User details not found. Did you wrap your app in a UserDetailsProvider?"
    );
  function r(d) {
    const h = d == null ? void 0 : d.split("@");
    if ((h == null ? void 0 : h.length) === 2)
      return h;
    throw new Error(
      `User email ${d} is not in the correct format. It should contain exactly one @ symbol.`
    );
  }
  const a = "48px";
  return /* @__PURE__ */ t.createElement(
    y,
    {
      direction: "row",
      gap: 2,
      alignItems: "center",
      sx: { maxWidth: "100%" }
    },
    /* @__PURE__ */ t.createElement(
      ge,
      {
        imgSrc: e.avatarImgSrc ?? void 0,
        size: a
      }
    ),
    /* @__PURE__ */ t.createElement(
      y,
      {
        direction: "column",
        maxWidth: `calc(100% - ${a} - ${n.spacing(2)})`
      },
      /* @__PURE__ */ t.createElement(
        A,
        {
          variant: "body1",
          sx: {
            flex: "0 1 auto",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }
        },
        e.name
      ),
      /* @__PURE__ */ t.createElement(y, { direction: "row" }, /* @__PURE__ */ t.createElement(
        A,
        {
          variant: "body2",
          noWrap: !0,
          sx: {
            flex: "0 1 auto",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }
        },
        (c = r(e.email)) == null ? void 0 : c[0]
      ), /* @__PURE__ */ t.createElement(
        A,
        {
          variant: "body2",
          sx: {
            flex: "1 0 auto",
            overflow: "hidden",
            whiteSpace: "pre"
          }
        },
        "@",
        (l = r(e.email)) == null ? void 0 : l[1]
      ))
    )
  );
}, Ve = (e) => {
  var s, m, v;
  const n = L(), r = P(n.breakpoints.down("md")), [a, c] = w(null), l = !!a, d = (u) => {
    c(u.currentTarget);
  }, h = () => {
    c(null);
  }, p = j(), o = (s = e.menuOptions) == null ? void 0 : s.some(
    (u) => !!u.to
  );
  if (o && !((m = e.routerProps) != null && m.component))
    throw new Error(
      "`routerProps.component` is required when using `to` in `profileMenuProps.menuOptions`."
    );
  const i = !!e.onLogOutClick, f = "profile-menu", g = "profile-menu-button";
  return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
    V,
    {
      id: g,
      variant: "text",
      startIcon: !r && /* @__PURE__ */ t.createElement(W, null),
      onClick: d,
      className: e.menuButtonClassName,
      sx: {
        color: n.palette.grey[800],
        "&:hover": { color: n.palette.primary.dark },
        backgroundColor: l ? n.palette.action.active : "transparent"
      },
      "data-testid": "profile-menu",
      "aria-label": r ? "Profile Menu" : void 0,
      "aria-controls": f,
      "aria-expanded": l,
      "aria-haspopup": "menu"
    },
    r ? /* @__PURE__ */ t.createElement(W, null) : p.name
  ), /* @__PURE__ */ t.createElement(
    Z,
    {
      id: f,
      open: l,
      anchorEl: a,
      onClose: h,
      anchorOrigin: { horizontal: "right", vertical: "bottom" },
      transformOrigin: { horizontal: "right", vertical: "top" },
      MenuListProps: {
        "aria-labelledby": g
      },
      sx: {
        "& .MuiPaper-root": {
          minWidth: "256px",
          maxWidth: "360px"
        },
        "& .MuiMenu-list": {
          paddingTop: n.spacing(2),
          paddingBottom: n.spacing(2)
        },
        "& .MuiMenuItem-root": {
          paddingLeft: n.spacing(3),
          paddingRight: n.spacing(3),
          whiteSpace: "normal",
          wordBreak: "break-word",
          "&+.MuiDivider-root": {
            marginTop: n.spacing(2),
            marginBottom: n.spacing(2)
          }
        }
      }
    },
    /* @__PURE__ */ t.createElement(
      B,
      {
        key: "User Details",
        className: e.userDetailsClassName,
        sx: {
          cursor: "default",
          "&:hover": { backgroundColor: "revert" },
          height: "inherit"
        },
        "data-testid": "user-details"
      },
      /* @__PURE__ */ t.createElement(J, null)
    ),
    (e.menuOptions || i) && /* @__PURE__ */ t.createElement(
      R,
      {
        sx: {
          borderColor: n.palette.grey[200],
          margin: n.spacing(2, 0)
        }
      }
    ),
    (v = e.menuOptions) == null ? void 0 : v.map((u) => /* @__PURE__ */ t.createElement(
      B,
      {
        key: u.label,
        onClick: (C) => {
          var E;
          (E = u.onClick) == null || E.call(u, C), h();
        },
        "data-testid": u["data-testid"],
        ...o ? { to: u.to, component: e.routerProps.component } : { href: u.href, component: "a" }
      },
      u.label
    )),
    e.menuOptions && i && /* @__PURE__ */ t.createElement(
      R,
      {
        sx: {
          borderColor: n.palette.grey[200]
        }
      }
    ),
    i && /* @__PURE__ */ t.createElement(
      B,
      {
        component: "div",
        key: "Log Out",
        onClick: (u) => {
          var C;
          (C = e.onLogOutClick) == null || C.call(e, u), h();
        },
        "data-testid": "log-out"
      },
      "Log out"
    )
  ));
}, He = (e) => {
  var g;
  const n = L(), [r, a] = w(null), [c, l] = w(
    e.defaultSelectedApp
  ), d = !!r, h = (s) => {
    a(s.currentTarget);
  }, p = () => {
    a(null);
  }, o = "app-switcher-menu", i = "app-switcher-menu-button", f = P(n.breakpoints.down("md"));
  return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
    V,
    {
      id: i,
      "aria-label": "App Switcher",
      onClick: h,
      sx: {
        color: n.palette.grey[800],
        "&:hover": { color: n.palette.primary.dark },
        backgroundColor: d ? n.palette.action.active : "transparent"
      },
      "aria-controls": o,
      "aria-expanded": d,
      "aria-haspopup": "menu"
    },
    /* @__PURE__ */ t.createElement(we, null)
  ), /* @__PURE__ */ t.createElement(
    Z,
    {
      id: o,
      open: d,
      anchorEl: r,
      onClose: p,
      anchorOrigin: f ? { horizontal: "right", vertical: "bottom" } : { vertical: "bottom", horizontal: "left" },
      transformOrigin: f ? { horizontal: "right", vertical: "top" } : { vertical: "top", horizontal: "left" },
      sx: {
        "& .MuiPaper-root": {
          minWidth: "256px",
          maxWidth: "360px"
        },
        "& .MuiMenuItem-root": {
          whiteSpace: "normal",
          wordBreak: "break-word"
        }
      },
      MenuListProps: {
        "aria-labelledby": i
      }
    },
    (g = e.appOptions) == null ? void 0 : g.map((s) => /* @__PURE__ */ t.createElement(
      ve,
      {
        key: s.label,
        label: s.label,
        value: s.label,
        "data-testid": s["data-testid"],
        variant: "checkmark",
        onClick: (m) => {
          l(s.label), s.onClick(m), p();
        },
        selected: c === s.label
      }
    ))
  ));
}, xe = ({
  anchorElMap: e,
  setAnchorElMap: n,
  selectedValue: r,
  ...a
}) => {
  const c = L();
  return /* @__PURE__ */ t.createElement(t.Fragment, null, Array.from(e.keys()).map((l) => {
    var p;
    const d = e.get(l), h = (p = a.tabs.find(
      (o, i) => o.value === l
    )) == null ? void 0 : p.menuProps;
    return h ? /* @__PURE__ */ t.createElement(
      Z,
      {
        anchorEl: d,
        open: !!d,
        onClose: () => U(l, e, n),
        key: l,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left"
        },
        sx: {
          "& .MuiPaper-root": {
            width: "244px"
          },
          "& .MuiMenuItem-root": {
            whiteSpace: "normal",
            wordBreak: "break-word"
          },
          top: c.spacing(0.5)
        }
      },
      h.map((o) => {
        const i = r === (o.to ?? o.value);
        return /* @__PURE__ */ t.createElement(
          B,
          {
            "aria-selected": i,
            selected: i,
            key: o.value,
            sx: {
              paddingLeft: c.spacing(1)
            },
            onClick: (f) => {
              var g;
              (g = a.onChange) == null || g.call(a, f, o.value), U(l, e, n);
            },
            component: a.component,
            href: o.href,
            to: o.to
          },
          /* @__PURE__ */ t.createElement(S, { sx: { paddingLeft: c.spacing(1) } }, o.label),
          i && /* @__PURE__ */ t.createElement(Ce, { sx: { marginLeft: c.spacing(1) } })
        );
      })
    ) : (console.error(`No menu items found for tab ${l}`), /* @__PURE__ */ t.createElement(t.Fragment, null));
  }));
};
function b(e, n) {
  if (!e || typeof e != "function")
    throw new Error("useComponentStylesFromTheme: selector must be a function");
  const r = L(), a = e(r);
  return Y(r, a, n);
}
function Y(e, n, r) {
  return n && typeof n == "function" ? n({
    ownerState: r,
    theme: e
  }) : n;
}
const ee = ({
  tabs: e,
  anchorElMap: n,
  setAnchorElMap: r,
  navTabBarRef: a,
  selectedTabValue: c,
  ...l
}) => {
  var g;
  const d = L(), h = k(e), p = {
    tabs: e,
    ...l
  }, o = b(
    (s) => {
      var m, v, u;
      return (u = (v = (m = s.components) == null ? void 0 : m.NavigationalTabBar) == null ? void 0 : v.styleOverrides) == null ? void 0 : u.tabs;
    },
    p
  ), i = b(
    (s) => {
      var m, v, u;
      return (u = (v = (m = s.components) == null ? void 0 : m.NavigationalTabBar) == null ? void 0 : v.styleOverrides) == null ? void 0 : u.toolbar;
    },
    p
  ), f = b(
    (s) => {
      var m, v, u;
      return (u = (v = (m = s.components) == null ? void 0 : m.NavigationalTabBar) == null ? void 0 : v.styleOverrides) == null ? void 0 : u.paper;
    },
    p
  );
  if (h && !((g = l.routerProps) != null && g.component))
    throw new Error(
      "The `routerProps.component` prop for AppBar is required when using react-router"
    );
  return /* @__PURE__ */ t.createElement(
    ae,
    {
      className: "mui-fixed",
      sx: { ...f }
    },
    /* @__PURE__ */ t.createElement(
      z,
      {
        sx: {
          ...i
        }
      },
      /* @__PURE__ */ t.createElement(
        le,
        {
          id: l.id,
          value: c,
          onChange: (s, m) => {
            var u;
            const v = e.find((C) => C.value === m);
            v != null && v.menuProps || (u = l.onChange) == null || u.call(l, s, m);
          },
          role: "navigation",
          TabIndicatorProps: { hidden: !0 },
          ref: a,
          sx: { ...o }
        },
        e.map((s) => {
          var C, E, x;
          const m = {
            ...s
          }, v = Y(
            d,
            (x = (E = (C = d.components) == null ? void 0 : C.NavigationalTabBar) == null ? void 0 : E.styleOverrides) == null ? void 0 : x.tab,
            { ...m }
          ), u = n.get(s.value);
          return /* @__PURE__ */ t.createElement(
            ie,
            {
              value: s.value,
              label: /* @__PURE__ */ t.createElement(A, { variant: "subtitle2", component: "p" }, s.label),
              key: s.value,
              "data-testid": s["data-testid"],
              sx: { ...v },
              className: u ? "Eds-tabOpened" : "",
              ...s.menuProps ? {
                onClick: (re) => {
                  Se(
                    re,
                    s.value,
                    n,
                    r
                  );
                },
                icon: u ? /* @__PURE__ */ t.createElement(K, null) : /* @__PURE__ */ t.createElement(_, null),
                iconPosition: "end",
                component: "button"
              } : h ? {
                component: l.routerProps.component,
                to: s.to
              } : {
                component: "a",
                href: s.href
              }
            }
          );
        })
      ),
      /* @__PURE__ */ t.createElement(
        xe,
        {
          tabs: e,
          onChange: l.onChange,
          anchorElMap: n,
          setAnchorElMap: r,
          selectedValue: h ? l.pathname : l.value,
          component: h ? l.routerProps.component : "a"
        }
      )
    )
  );
}, be = (e) => {
  var h, p;
  if (!((h = e.routerProps) != null && h.component))
    throw new Error(
      "The `routerProps.component` prop for AppBar is required when using react-router"
    );
  if (!((p = e.routerProps) != null && p.useLocation))
    throw new Error(
      "The `routerProps.useLocation` prop for AppBar is required when using react-router"
    );
  const r = e.routerProps.useLocation().pathname, a = r == null ? void 0 : r.toLowerCase();
  function c(o, i) {
    var s, m;
    if (!((s = e.routerProps) != null && s.resolvePath))
      throw new Error(
        "The `routerProps.resolvePath` prop for AppBar is required when using react-router"
      );
    const f = (m = e.routerProps.resolvePath(o).pathname) == null ? void 0 : m.toLowerCase();
    return i === f || i.startsWith(f) && i.charAt(f.length) === "/";
  }
  const l = e.tabs.find((o) => {
    let i;
    return o.menuProps ? i = o.menuProps.find(
      (g) => c(g.to, a)
    ) !== void 0 : i = c(o.to, a), i;
  }), d = e.value ?? (l == null ? void 0 : l.value) ?? !1;
  return /* @__PURE__ */ t.createElement(
    ee,
    {
      ...e,
      selectedTabValue: d,
      pathname: r
    }
  );
};
function U(e, n, r) {
  r(new Map(n.set(e, null)));
}
function Se(e, n, r, a) {
  a(new Map(r.set(n, e.currentTarget)));
}
function k(e) {
  return e.some((n) => n.menuProps ? n.menuProps.some((r) => !!r.to) : !!n.to);
}
const ke = (e) => {
  var p, o;
  const [n, r] = w(/* @__PURE__ */ new Map());
  N(
    function() {
      let f = /* @__PURE__ */ new Map();
      e.tabs.forEach((g) => {
        g.menuProps && (f = n.set(g.value, null));
      }), r(f);
    },
    [e.tabs]
  );
  const a = I("div")(({ theme: i }) => ({
    ...i.mixins.toolbar,
    // will be overridden by breakpoint logic, so needs to be set in `styles` prop
    minHeight: c,
    height: c
  })), [c, l] = w(
    void 0
  ), d = G(null);
  X(() => {
    var i;
    l((i = d.current) == null ? void 0 : i.clientHeight);
  }, []);
  const h = k(e.tabs);
  if (h && !((p = e.routerProps) != null && p.component))
    throw new Error(
      "The `routerProps.component` prop for AppBar is required when using react-router"
    );
  return /* @__PURE__ */ t.createElement(t.Fragment, null, h ? /* @__PURE__ */ t.createElement(
    be,
    {
      id: e.id,
      onChange: e.onChange,
      value: e.value,
      tabs: e.tabs,
      anchorElMap: n,
      setAnchorElMap: r,
      navTabBarRef: d,
      maxWidth: e.maxWidth,
      routerProps: e.routerProps
    }
  ) : /* @__PURE__ */ t.createElement(
    ee,
    {
      id: e.id,
      onChange: e.onChange,
      value: e.value,
      tabs: e.tabs,
      anchorElMap: n,
      setAnchorElMap: r,
      navTabBarRef: d,
      selectedTabValue: ((o = e.value) == null ? void 0 : o.split("/")[0]) ?? !1,
      maxWidth: e.maxWidth,
      routerProps: e.routerProps
    }
  ), /* @__PURE__ */ t.createElement(a, { style: { minHeight: (c ?? 0) + 1 } }));
}, q = I(T, {
  name: "NavigationalDrawer",
  slot: "navListItemButton"
})({}), te = ({
  openMenusMap: e,
  handleOpenMenusMap: n,
  selectedListItem: r,
  ...a
}) => {
  var p;
  const c = L(), l = k(a.tabs);
  if (l && !((p = a.routerProps) != null && p.component))
    throw new Error(
      "The `routerProps.component` prop for AppBar is required when using react-router"
    );
  const d = ({
    tab: o,
    isSelected: i,
    menuIsOpen: f
  }) => /* @__PURE__ */ t.createElement(
    q,
    {
      component: "div",
      onClick: () => {
        n(new Map(e.set(o.value, !f)));
      },
      key: o.value
    },
    /* @__PURE__ */ t.createElement(
      S,
      {
        primary: o.label,
        primaryTypographyProps: {
          sx: {
            ...c.typography.subtitle1,
            fontSize: "18px",
            ...i && {
              color: c.palette.primary.main,
              fontWeight: "600"
            }
          }
        }
      }
    ),
    f ? /* @__PURE__ */ t.createElement(K, null) : /* @__PURE__ */ t.createElement(_, null)
  ), h = ({
    tab: o,
    isSelected: i,
    isMenuItem: f
  }) => {
    const g = f ? {
      pl: i ? `calc(${c.spacing(6)} - 2px)` : 6
    } : { pl: i ? `calc(${c.spacing(3)} - 2px)` : 3 };
    return /* @__PURE__ */ t.createElement(
      q,
      {
        href: l ? void 0 : o.href,
        onClick: (s) => {
          var m;
          (m = a.onChange) == null || m.call(a, s, o.value), a.onClose();
        },
        selected: i,
        sx: { ...g },
        ...l ? {
          to: o.to,
          component: a.routerProps.component
        } : {
          href: o.href,
          component: "a"
        }
      },
      /* @__PURE__ */ t.createElement(
        S,
        {
          primary: o.label,
          primaryTypographyProps: {
            sx: {
              ...c.typography.subtitle1,
              fontSize: c.typography.h3.fontSize,
              ...i && {
                color: c.palette.primary.main,
                fontWeight: "600"
              }
            }
          }
        }
      )
    );
  };
  return /* @__PURE__ */ t.createElement(O, { sx: { p: 0 }, component: "nav" }, a.tabs.map((o) => {
    var g;
    const i = e.get(o.value), f = r === o.value;
    return o.menuProps ? (
      // Need React.Fragment around wrapped components to add key
      // For some reason React doesn't see the key on wrapped components
      // Collapse also must not be wrapped or else transition won't work
      /* @__PURE__ */ t.createElement(t.Fragment, { key: o.value }, /* @__PURE__ */ t.createElement(
        d,
        {
          tab: o,
          menuIsOpen: i,
          isSelected: f
        }
      ), /* @__PURE__ */ t.createElement(ce, { in: i, timeout: "auto", unmountOnExit: !0 }, /* @__PURE__ */ t.createElement(O, { component: "div", disablePadding: !0 }, (g = o.menuProps) == null ? void 0 : g.map(
        (s) => {
          const m = r === s.value;
          return /* @__PURE__ */ t.createElement(t.Fragment, { key: s.value }, /* @__PURE__ */ t.createElement(
            h,
            {
              tab: s,
              isSelected: m,
              isMenuItem: !0
            }
          ));
        }
      ))))
    ) : /* @__PURE__ */ t.createElement(t.Fragment, { key: o.value }, /* @__PURE__ */ t.createElement(h, { tab: o, isSelected: f, isMenuItem: !1 }));
  }));
}, ne = (e) => {
  var h, p, o, i, f, g, s;
  const n = L(), r = P(n.breakpoints.down("sm")), a = I(z)({
    justifyContent: "flex-end",
    [n.breakpoints.up("xs")]: {
      padding: `0 ${n.spacing(3)}`
    }
  }), c = (p = (h = e.profileMenuProps) == null ? void 0 : h.menuOptions) == null ? void 0 : p.some(
    (m) => !!m.to
  );
  if (c && !((o = e.routerProps) != null && o.component))
    throw new Error(
      "The `routerProps.component` prop for AppBar is required when using react-router"
    );
  const l = {
    ...e
  }, d = b(
    (m) => {
      var v, u, C;
      return (C = (u = (v = m.components) == null ? void 0 : v.NavigationalDrawer) == null ? void 0 : u.styleOverrides) == null ? void 0 : C.defaultRoot;
    },
    { ...l }
  );
  return /* @__PURE__ */ t.createElement(
    se,
    {
      anchor: "left",
      open: e.open,
      onClose: () => e.onClose(),
      sx: { ...d }
    },
    /* @__PURE__ */ t.createElement(y, { gap: 3, p: `${n.spacing(3)} 0` }, /* @__PURE__ */ t.createElement(a, null, /* @__PURE__ */ t.createElement(
      V,
      {
        "aria-label": "Close",
        onClick: () => e.onClose(),
        sx: {
          color: n.palette.grey[800],
          "&:hover": { color: n.palette.primary.dark }
        }
      },
      /* @__PURE__ */ t.createElement(Le, null)
    )), (r || e.searchInputProps) && /* @__PURE__ */ t.createElement(y, { gap: 3, padding: `0 ${n.spacing(3)}` }, r && /* @__PURE__ */ t.createElement(J, null), e.searchInputProps && /* @__PURE__ */ t.createElement(Q, { ...e.searchInputProps }), (r && e.profileMenuProps || e.tabs) && /* @__PURE__ */ t.createElement(D, { emphasis: "low" })), e.children, r && /* @__PURE__ */ t.createElement(y, { gap: 3 }, e.tabs && ((i = e.profileMenuProps) == null ? void 0 : i.onLogOutClick) && /* @__PURE__ */ t.createElement(ue, { padding: `0 ${n.spacing(3)}` }, /* @__PURE__ */ t.createElement(D, { emphasis: "low" })), /* @__PURE__ */ t.createElement(O, { sx: { p: 0 }, component: "nav" }, (g = (f = e.profileMenuProps) == null ? void 0 : f.menuOptions) == null ? void 0 : g.map((m) => /* @__PURE__ */ t.createElement(
      T,
      {
        key: m.label,
        onClick: (v) => {
          var u;
          (u = m.onClick) == null || u.call(m, v), e.onClose();
        },
        sx: { padding: `${n.spacing(1)} ${n.spacing(3)}` },
        ...c ? {
          to: m.to,
          component: e.routerProps.component
        } : { href: m.href }
      },
      /* @__PURE__ */ t.createElement(
        S,
        {
          primary: m.label,
          primaryTypographyProps: {
            sx: {
              ...n.typography.body1
            }
          }
        }
      )
    )), ((s = e.profileMenuProps) == null ? void 0 : s.onLogOutClick) && /* @__PURE__ */ t.createElement(
      T,
      {
        component: "div",
        key: "Log Out",
        onClick: (m) => {
          var v, u;
          (u = (v = e.profileMenuProps) == null ? void 0 : v.onLogOutClick) == null || u.call(v, m), e.onClose();
        },
        sx: { padding: `${n.spacing(1)} ${n.spacing(3)}` }
      },
      /* @__PURE__ */ t.createElement(
        S,
        {
          primary: "Log Out",
          primaryTypographyProps: {
            sx: {
              ...n.typography.body1
            }
          }
        }
      )
    ))))
  );
}, Ie = (e) => {
  var h;
  if (!((h = e.routerProps) != null && h.useLocation))
    throw new Error(
      "The `routerProps.useLocation` prop for AppBar is required when using react-router"
    );
  const r = e.routerProps.useLocation().pathname, a = r == null ? void 0 : r.toLowerCase();
  function c(p, o) {
    var g, s;
    if (!((g = e.routerProps) != null && g.resolvePath))
      throw new Error(
        "The `routerProps.resolvePath` prop for AppBar is required when using react-router"
      );
    const i = (s = e.routerProps.resolvePath(p).pathname) == null ? void 0 : s.toLowerCase();
    return o === i || o.startsWith(i) && o.charAt(i.length) === "/";
  }
  const l = e.tabs.find((p) => {
    let o;
    return p.menuProps ? o = p.menuProps.find(
      (f) => c(f.to, a)
    ) !== void 0 : o = c(p.to, a), o;
  }), d = e.value ?? (l == null ? void 0 : l.value);
  return N(() => {
    if (d) {
      const p = d == null ? void 0 : d.split("/"), o = p == null ? void 0 : p[0];
      let i = e.openMenusMap;
      e.tabs.forEach((f) => {
        o === f.value ? i = e.openMenusMap.set(f.value, !0) : i = e.openMenusMap.set(f.value, !1);
      }), e.handleOpenMenusMap(i);
    }
  }, [r]), /* @__PURE__ */ t.createElement(ne, { ...e }, /* @__PURE__ */ t.createElement(te, { ...e, selectedListItem: d }));
}, Ae = (e) => {
  const [n, r] = w(
    /* @__PURE__ */ new Map()
  ), a = (c) => {
    r(new Map(c));
  };
  return N(
    function() {
      if (e.tabs && !k(e.tabs)) {
        let l = /* @__PURE__ */ new Map();
        e.tabs.forEach((d) => {
          d.menuProps && (d.menuProps.some((h) => h.value === e.value) ? l = l.set(d.value, !0) : l = n.set(d.value, !1));
        }), r(l);
      }
    },
    [e.tabs, e.value]
  ), e.tabs && k(e.tabs) ? /* @__PURE__ */ t.createElement(
    Ie,
    {
      ...e,
      tabs: e.tabs,
      openMenusMap: n,
      handleOpenMenusMap: a
    }
  ) : /* @__PURE__ */ t.createElement(ne, { ...e }, e.tabs && /* @__PURE__ */ t.createElement(
    te,
    {
      ...e,
      tabs: e.tabs,
      openMenusMap: n,
      handleOpenMenusMap: a,
      selectedListItem: e.value
    }
  ));
}, Be = (e) => {
  const n = L();
  P(n.breakpoints.down("md"));
  const r = P(n.breakpoints.down("sm"));
  return /* @__PURE__ */ t.createElement(
    V,
    {
      id: "guest-access-button",
      variant: "text",
      startIcon: !r && /* @__PURE__ */ t.createElement($, null),
      onClick: (a) => {
        var c;
        (c = e.onLogInClick) == null || c.call(e, a);
      },
      sx: {
        color: n.palette.grey[800],
        "&:hover": { color: n.palette.primary.dark },
        backgroundColor: "transparent"
      },
      "data-testid": "guest-access-log-in",
      "aria-label": "Guest Log In"
    },
    r ? /* @__PURE__ */ t.createElement($, null) : "Log in"
  );
}, Te = I(me)(({ variant: e }) => ({
  "& .MuiBadge-badge": {
    px: 8,
    height: e === "dot" ? 8 : 16
  }
})), Oe = ({
  onClick: e,
  count: n,
  "data-testid": r
}) => {
  const a = L(), c = n > 0 ? /* @__PURE__ */ t.createElement(
    Te,
    {
      variant: "dot",
      color: "primary",
      "data-testid": "notification-badge"
    },
    /* @__PURE__ */ t.createElement(F, null)
  ) : /* @__PURE__ */ t.createElement(F, null);
  return /* @__PURE__ */ t.createElement(
    V,
    {
      "aria-label": "Notification Button",
      "data-testid": r,
      sx: {
        color: a.palette.grey[800],
        "&:hover": { color: a.palette.primary.dark }
      },
      onClick: e
    },
    c
  );
}, Ne = (e) => {
  var c;
  const n = Ee().themeName;
  let r = e.logoSrc || (n === "Unstable Single UI" ? ye : he);
  if (e.isXSmallScreen && (e.xSmallLogoSrc ? r = e.xSmallLogoSrc : e.logoSrc ? r = e.logoSrc : r = Me), e.to && !((c = e.routerProps) != null && c.component))
    throw new Error(
      "`routerProps.component` is required when using `to` in `logoProps`."
    );
  const a = () => /* @__PURE__ */ t.createElement(
    "img",
    {
      src: r,
      alt: e.alt || "App Bar Logo",
      style: { cursor: "pointer" }
    }
  );
  return e.to ? t.createElement(
    e.routerProps.component,
    {
      to: e.to,
      style: { display: "flex", alignItems: "center" }
    },
    /* @__PURE__ */ t.createElement(a, null)
  ) : /* @__PURE__ */ t.createElement("a", { href: e.href, style: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ t.createElement(a, null));
}, Qe = (e) => {
  var m, v;
  const n = I("div")(({ theme: u }) => ({
    ...u.mixins.toolbar,
    height: (r ?? 0) + 1
  })), [r, a] = w(
    void 0
  ), c = G(null);
  X(() => {
    var u;
    a((u = c.current) == null ? void 0 : u.clientHeight);
  }, []);
  const l = L(), d = P(l.breakpoints.down("md")), h = P(l.breakpoints.down("sm")), [p, o] = w(!1), i = e.guestAccess, f = e.guestAccess ? e.guestAccessProps.displayLogIn : !1, g = !i || i && ((m = e.guestAccessProps) == null ? void 0 : m.guestNavigation), s = b(
    (u) => {
      var C, E, x;
      return (x = (E = (C = u.components) == null ? void 0 : C.AppBar) == null ? void 0 : E.styleOverrides) == null ? void 0 : x.toolbar;
    },
    { ...e }
  );
  return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(de, { ref: c }, /* @__PURE__ */ t.createElement(z, { sx: { ...s } }, (h || d && (e.navTabBarProps || e.searchInputProps)) && g && /* @__PURE__ */ t.createElement(
    V,
    {
      "aria-label": "Navigation Drawer",
      onClick: () => o(!0),
      sx: {
        color: l.palette.grey[800],
        "&:hover": { color: l.palette.primary.dark },
        marginRight: l.spacing(1)
      }
    },
    /* @__PURE__ */ t.createElement(Pe, null)
  ), /* @__PURE__ */ t.createElement(
    Ne,
    {
      ...e.logoProps,
      isXSmallScreen: h,
      ...(v = e.logoProps) != null && v.to ? { routerProps: e.routerProps } : {}
    }
  ), /* @__PURE__ */ t.createElement(
    y,
    {
      direction: "row",
      gap: 1,
      width: "100%",
      flexGrow: 1,
      justifyContent: "flex-end",
      ml: 1
    },
    i && f && "guestAccessProps" in e && /* @__PURE__ */ t.createElement(Be, { ...e.guestAccessProps }),
    !i && /* @__PURE__ */ t.createElement(t.Fragment, null, !d && e.searchInputProps && // Search Input should move inside Navigational Drawer on xs and sm screens
    /* @__PURE__ */ t.createElement(Q, { ...e.searchInputProps }), e.notificationProps && /* @__PURE__ */ t.createElement(Oe, { ...e.notificationProps }), e.appSwitcherProps && /* @__PURE__ */ t.createElement(He, { ...e.appSwitcherProps }), !h && // Profile Menu should move inside Navigational Drawer on xs screens
    /* @__PURE__ */ t.createElement(
      Ve,
      {
        ...e.profileMenuProps,
        routerProps: e.routerProps
      }
    ))
  ))), /* @__PURE__ */ t.createElement(n, null), g && /* @__PURE__ */ t.createElement(t.Fragment, null, d && /* @__PURE__ */ t.createElement(
    Ae,
    {
      open: p,
      onClose: () => o(!1),
      profileMenuProps: e.profileMenuProps,
      searchInputProps: e.searchInputProps,
      routerProps: e.routerProps,
      ...e.navTabBarProps
    }
  ), !d && e.navTabBarProps && /* @__PURE__ */ t.createElement(
    ke,
    {
      maxWidth: e.maxWidth,
      routerProps: e.routerProps,
      ...e.navTabBarProps
    }
  )));
};
export {
  Qe as A
};
